module.exports = __webpack_public_path__ + "static/buyer-pickup-time-0295971af6896d4d042e66a259784837.gif";